import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Funeral } from '../../../../../../../types/SMT';
import LabeledParamFallback from '../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import RiskObjectSelectRadio from '../RiskObjectSelectRadio';

interface Props {
  partyGroup: Funeral;
  isSelected: boolean;
  onSelect: () => void;
}

const PartyGroupSelectRadio: React.FC<Props> = ({
  partyGroup,
  isSelected,
  onSelect,
}) => {
  const { t } = useTranslation();
  const { name, parties } = partyGroup;

  return (
    <RiskObjectSelectRadio
      isSelected={isSelected}
      onSelect={onSelect}
      icon={<Icon name="GeneralRiskObjectsFuneral" />}
      title={name || ''}
    >
      <LabeledParamFallback label={`${t('Person')} 1`}>
        {t(parties?.[0].first_name || '')} {t(parties?.[0].last_name || '')}
      </LabeledParamFallback>
      {parties?.[1] && (
        <LabeledParamFallback label={`${t('Person')} 2`}>
          {t(parties?.[1].first_name || '')} {t(parties?.[1].last_name || '')}
        </LabeledParamFallback>
      )}
    </RiskObjectSelectRadio>
  );
};

export default PartyGroupSelectRadio;
